// extracted by css-extract-rspack-plugin
export default {"wrapper":"_4fca8272","paginationRow":"_309a69c7","loadingWrapper":"_a9c349b4","spinnerWrapper":"_27ff2bef","noResultsRow":"_1b911e30"};